import React from "react";
import { Button, Tooltip, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 0,
    margin: theme.spacing(0.5),
  },
  secondary: {
    backgroundColor: theme.palette.secondary.light,
    "& .MuiButton-label": {
      color: theme.palette.secondary.main,
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.light,
    "& .MuiButton-label": {
      color: theme.palette.primary.main,
    },
  },
}));

const ActionButton = ({ color, children, onClick, title }) => {
  const classes = useStyles();
  const btn = (
    <Button className={`${classes.root} ${classes[color]}`} onClick={onClick}>
      {children}
    </Button>
  );

  return title ? <Tooltip title={title} arrow placement="top">{btn}</Tooltip> : btn;
};

export default ActionButton;
